module.exports = __webpack_public_path__ + "static/media/work.4539a6d2.jpg";